import ReactGA  from 'react-ga';

ReactGA.initialize("UA-136333768-1");

export default ReactGA